import { Injectable, inject } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { filter } from 'rxjs';
import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationLoadingService {
  private router = inject(Router);
  private loadingService = inject(LoadingService);
  private isConfigured = false;

  constructor() {
    this.configureNavigationLoading();
  }

  private configureNavigationLoading(): void {
    if (this.isConfigured) {
      return;
    }

    this.isConfigured = true;

    this.router.events
      .pipe(
        filter(event => 
          event instanceof NavigationStart ||
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        )
      )
      .subscribe(event => {
        if (event instanceof NavigationStart) {
          // Mostrar loading solo para navegaciones que no van a componentes con loading interno
          if (!event.url.includes('#') && !this.shouldSkipLoading(event.url)) {
            
            this.loadingService.show();
          }
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          // Ocultar loading después de un pequeño delay solo si no es una ruta con loading interno
          // Las rutas con loading interno manejan su propio ciclo de vida del loading
          if (!this.shouldSkipLoading(event.url)) {
            
            setTimeout(() => {
              this.loadingService.hide();
            }, 200);
          } else {
            
          }
        }
      });
  }

  private shouldSkipLoading(url: string): boolean {
    // Rutas que tienen su propio loading interno y no necesitan loading global
    // Solo se excluyen componentes con servicios que manejan su propio estado de loading
    const routesWithInternalLoading = [
      '/abogados/detalle/',  // Perfil del abogado - usa lawyerService.loading
      '/cuenta/reservas',    // Mis Reservas - usa reservationService.loading
      '/auth/scheduling',    // Programaciones - maneja su propio loading en ngOnInit
      '/auth/profile',       // Perfil - maneja su propio loading en ngOnInit
    ];

    return routesWithInternalLoading.some(route => url.includes(route));
  }
}
